import { useEffect, useState } from 'react';
import { FormOptions, FormSpecs } from '@/types';
import { fetchFormSpecs } from '@/services/yepcode';

const useFormSpecs = ({
  hostUrl,
  headers,
  team,
  processId,
}: FormOptions): {
  loading: boolean;
  formSpecs: FormSpecs | undefined;
  error: string | undefined;
} => {
  const [loading, setLoading] = useState<boolean>(true);
  const [formSpecs, setFormSpecs] = useState<FormSpecs | undefined>();
  const [error, setError] = useState<string | undefined>();

  useEffect(() => {
    fetchFormSpecs({
      hostUrl,
      headers,
      team,
      processId,
    })
      .then((fetchedFormSpecs) => {
        setFormSpecs(fetchedFormSpecs);
        return fetchedFormSpecs;
      })
      .catch(setError)
      .finally(() => {
        setLoading(false);
      });
  }, [hostUrl, headers, team, processId]);

  return {
    loading,
    formSpecs,
    error,
  };
};

export default useFormSpecs;
